<!--<contact-common-search [execMapDuplicate]="false" [isCompany]="true"></contact-common-search>-->
<company *ngIf="user && roleFeaturePermissions" [user]=user [roleFeaturePermissions]="roleFeaturePermissions" [isBulkCompany]="showBulkCompany"></company>
